import styled from "styled-components";

const ContentBoxWrapper = styled.div`
  border-radius: 12px;
  background: #00000099;
  padding: 21.14px 25.01px 20.36px 25.01px;
  position: relative;
  width: 100%;
  display: flex;
  gap: 16px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 12px;
    padding: 1px;
    background: linear-gradient(to right, #156a4ba6, #462373);
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;
  }
`;

type ContentBoxProps = {
  children: React.ReactNode;
};

// * refactor
export const ContentBox = ({ children }: ContentBoxProps) => (
  <ContentBoxWrapper>{children}</ContentBoxWrapper>
);

export const ContentBoxV2 = styled.div`
  flex-grow: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  padding: 23.9px 35.5px;
  border-radius: 16px;
  border: solid 1px rgba(8, 169, 138, 0.27);
  background-color: rgba(13, 42, 37, 0.56);
  color: #bfbfbf;
`;
